module.exports = __webpack_public_path__ + "img/500x300.b12460fc.jpg";